<template>
	<div>
		<error-dialog :errorObject="modalError" @onClose="modalError = null" />
		<B2bChat v-if="estaLogado && env && env.chat_ai_enabled && usuario && usuario.usuaInChatAi === 'S' && !inModoOndeEncontrar && !inModoCatalogoPublico && ['ROOT', 'ADMIN', 'REPRESENTANTE', 'PREPOSTO_REPRESE', 'VENDEDOR_INTERNO', 'VENDEDOR_EXTERNO', 'CLIENTE', 'PREPOSTO_CLIENTE', 'DROPSHIPPING'].includes(usuario.usuaRole)"
			:key="usuario.usuaId + ':' + usuario.usuaRole + ':' + usuario.usuaIdClieSelec + ':' + (clienteSelecionado && clienteSelecionado.clieId)"
			:usuario="usuario" :cliente="clienteSelecionado" />
		<template v-if="inModoOndeEncontrar">
			<OndeEncontrar/>
		</template>
		<template v-else-if="inModoCatalogoPublico">
			<Unit050 v-if="env" :usuario="usuarioCatalogoPublico"
				:dicionario="dicionarioCatalogoPublico" :env="env" />
		</template>
		<template v-else-if="estaLogado">
			<header>
				<div id="navbar-wrapper">
					<div class="navbar-fixed">
						<nav class="row ma-0">
							<div class="nav-wrapper col s12 pa-0" 
								:style="showCarrinhoView && $route.name != 'unit039' ? 'width: calc(100% - 300px);' : ''">
								<a href="javascript:return true;" ref="botaoMenu" data-activates="slide-out"
									class="button-collapse">
									<i class="material-icons">menu</i>
								</a>
								<div>
									<a class="brand-logo" @click.prevent="vaiParaHome">
										<img :alt="nomeEmpresa" :src="logo" class="responsive-img" :class="{'sombra-branca-logo':env.aplica_sombra_branca_logo }" />
									</a>
									<ul id="nav-mobile" class="right hide-on-med-and-down">
										<li><a @click.prevent="efetuarLogoff"><i
													class="material-icons medium">exit_to_app</i></a></li>
										<router-link v-if="env" tag="li" :to="env.unit_meus_dados">
											<a><i class="material-icons medium">settings</i></a>
										</router-link>
										<li v-if="urlVideoAjuda">
											<a class="tooltipped" data-position="bottom"
												data-tooltip="Video explicativo da tela atual"
												@click.prevent="abrirNovaAbaVideoAjuda">
												<i class="material-icons medium">live_tv</i>
											</a>
										</li>
										<li>
											<a class="tooltipped" style="padding: 0.8rem;"
												@click.prevent="abrirNovaAbaWhatsApp" data-position="bottom"
												data-tooltip="Fale conosco no WhatsApp">
												<img src="./assets/whatsapp.png" width="40">
											</a>
										</li>


										<li v-if="inModoCarrinho && clienteSelecionado" class="icon-carrinho tooltipped right hide-on-med-and-down"
											data-position="bottom" :data-tooltip="getMsgIconCarrinho()"
											@click="openSideViewKart">
											<a style="outline: solid 2px;width: 38px;height: 38px;"
												class="btn-floating transparent" data-badge-caption="3">
												<i class="material-icons">shopping_cart</i>
											</a>
											<span v-if="quantidadeDetalhes" class="center circle secondary-color"
												data-badge-caption="7"
												:style="quantidadeDetalhes > 99 ? 'line-height: 2.1;font-size: 10px;' : ''"
												style="
											height: 20px;
											width: 20px;
											line-height: 1.4;
											top: 7px;
											right: 7px;
											position: absolute;
											outline: solid 2px;
											z-index: 5;
											">{{ quantidadeDetalhes }}</span>
										</li>
									</ul>
								</div>

								<!--
								<a
									class="tooltipped pa-1 right"
									@click.prevent="abrirNovaAbaWhatsApp" 
									data-position="left" 
									data-tooltip="Fale conosco no WhatsApp"
									v-if="sch.show_on_small">
									<img src="./assets/whatsapp.png" width="30">
								</a>
								-->

								<div v-if="inModoCarrinho && clienteSelecionado" class="tooltipped right pt-1 pr-1 hide-on-large-only"
									data-position="bottom" :data-tooltip="getMsgIconCarrinho()"
									@click="$router.push({ path: 'unit039' })">
									<a style="outline: solid 2px;width: 38px;height: 38px;"
										class="btn-floating transparent">
										<i class="material-icons" style="line-height: 40px;">shopping_cart</i>
									</a>
									<span v-if="quantidadeDetalhes" class="center circle secondary-color"
										:style="quantidadeDetalhes > 99 ? 'line-height: 2.1;font-size: 10px;' : ''" style="
										height: 20px;
										width: 20px;
										line-height: 1.4;
										top: 7px;
										right: 7px;
										position: absolute;
										outline: solid 2px;
										z-index: 5;
										">{{ quantidadeDetalhes }}</span>
								</div>
							</div>

							<CarrinhoView v-if="usuario && usuario.usuaIdPedc && clienteSelecionado" ref="CarrinhoView" style="width: 300px;"
								class="col s12 m2 pa-0 right" :idPedido="usuario.usuaIdPedc"
								:env="env"
								:showCarrinho="showCarrinhoView && $route.name != 'unit039'"
								@loaderNotifier="loadNotifier" @defineQtd="defineQtd" @fechar="showCarrinhoView = false"
								@onRemoveTodos="confirmarRemoveTodos" />
						</nav>
					</div>
				</div>
			</header>

			<div id="main" class="row ma-0" v-if="env">
				<top-loader :pilha="topLoader" />
				<div id="sidebar-wrapper">
					<aside id="left-sidebar-nav">
						<ul ref="slideOut" id="slide-out" class="side-nav fixed" v-if="env">
							<li style="line-height: 34px;">
								<div class="userView ma-0 pb-1">
									<div class="background">
										<img src="webapi/resource/office.jpg"
											style="filter: brightness(0.4); width: 100%;">
									</div>
									<router-link :to="env.unit_meus_dados"><img class="circle"
											:src="imagemUsuario"></router-link>
									<router-link :to="env.unit_meus_dados">
										<span class="white-text fonte ultra-small linhasJuntas truncate">
											{{ usuario.usuaNome }}
										</span>
										<span class="white-text fonte ultra-small linhasJuntas truncate">
											{{ usuario.usuaEmail }}
										</span>
										<span v-if="usuario.usuaRefExterno" class="white-text fonte ultra-small linhasJuntas truncate">
											{{ usuario.usuaRefExterno }}
										</span>
									</router-link>
									<span v-if="env && env.app_version" class="white-text">
										v{{ env.app_version }}
									</span>
								</div>
							</li>

							<li v-if="clienteSelecionado">
								<span class="ultra-small linhasJuntas" style="padding-left: 15px;">Cliente
									Selecionado:</span>
								<span class="ultra-small linhasJuntas truncate fonte w600"
									style="padding-left: 15px;">{{ clienteSelecionado.clieNome }}</span>
							</li>
							<template v-for="(grp, index) in menuExibir">
								<div :key="'grp-' + index">
									<li>
										<div class="divider ma-0"></div>
									</li>
									<li v-if="grp.nome"><a class="subheader">{{ grp.nome }}</a></li>
									<template v-for="(item, id) in grp.itens">
										<li :key="'item-' + id" v-if="item.path.startsWith('http')">
											<a :href="item.path" target="_blank" class="menu-link-with-badge">
												<i class="material-icons">{{ item.icon }}</i>
												<span>{{ item.nome }}</span>
												<span v-if="item.badge" class="menu-pill-new secondary-color white-text">{{ item.badge }}</span>
											</a>
										</li>
										<router-link v-else tag="li" :to="item.path" :key="'itemAAA-' + id">
											<a :class="defineCorMenu(item)" :style="defineCorMenu(item)"
												class="menu-link-with-badge" style="border-bottom: 1px solid white;">
												<i class="material-icons" :class="defineCorTextoMenu(item)"
													:style="defineCorTextoMenu(item)">{{ item.icon }}</i>
												<span :class="defineCorTextoMenu(item)"
													:style="defineCorTextoMenu(item)">{{ item.nome }}</span>
												<span v-if="item.badge" class="menu-pill-new secondary-color white-text">{{ item.badge }}</span>
												<template v-if="item.unit == 'unit_clientes'">
													<span v-if="clienteSelecionado" class="badge new"
														data-badge-caption="">selecionado</span>
												</template>
												<template v-if="item.unit == 'unit_fazer_pedido'">
													<span v-if="quantidadeDetalhes" class="badge new"
														data-badge-caption="">{{ quantidadeDetalhes }}</span>
												</template>
												<template v-if="item.unit == 'unit_carrinho'">
													<span v-if="quantidadeDetalhes" class="badge new"
														data-badge-caption="">{{ quantidadeDetalhes }}</span>
												</template>
												<template v-else-if="item.unit == 'unit_publicacoes'">
													<span v-if="isNovaPublicacao" class="badge new"></span>
												</template>
												<template v-if="item.unit == 'unit_cobranca_eletronica'">
													<span v-if="qtdCoelAbertas" class="badge new"
														data-badge-caption="">{{ qtdCoelAbertas }}</span>
												</template>
												<template v-if="item.unit == 'unit_informacoes_produto'">
													<span v-if="qtdItemSemCadAdicionais" class="badge new"
														data-badge-caption="">{{ qtdItemSemCadAdicionais }}</span>
												</template>
												<template
													v-if="item.unit == 'unit_integracao_marketplaces' && errorsAuthMarketplace.length > 0">
													<span class="badge new tooltipped" data-badge-caption=""
														data-position="right"
														:data-tooltip="`erro${errorsAuthMarketplace.length > 1 ? 's' : ''} de autenticação`">
														{{ errorsAuthMarketplace.length }}
													</span>
												</template>
											</a>
										</router-link>
									</template>

								</div>
							</template>
							<router-link tag="li" to="/unit056" v-if="clienteSelecionado && usuario && ['CLIENTE', 'DROPSHIPPING'].includes(usuario.usuaRole)">
								<a><i class="material-icons">file_download</i>Exportar XML de compras</a>
							</router-link>
							<li v-if="mostrarlink">
								<a href="#" @click.prevent="baixarPlanilhaItens">
									<i class="material-icons">file_download</i>
									Planilha de Itens
								</a>
							</li>
							<li
								v-if="clienteSelecionado && temPerfil(usuario.usuaRole, ['CLIENTE', 'DROPSHIPPING']) && usuario.usuaInAcessoApiPublica == 'S'">
								<a href="#" @click.prevent="baixarPlanilhaDropshipping">
									<i class="material-icons">file_download</i>
									Planilha Dropshipping
								</a>
							</li>
							<li
								v-if="['ADMIN', 'ROOT', 'COMPRAS', 'MARKETING'].includes(usuario.usuaRole) && menuExibir && menuExibir.length > 0">
								<a href="#" @click.prevent="showDialogCatalogo = true">
									<i class="material-icons">dashboard</i>
									Gerador Cat&aacute;logo
								</a>
							</li>
							<li>
								<div class="divider ma-0"></div>
							</li>
							<router-link class="hide-on-large-only" tag="li" :to="env.unit_meus_dados">
								<a><i class="material-icons">settings</i>Configura&#231;&#245;es</a>
							</router-link>
							<li class="">
								<a href="#" @click.prevent="efetuarLogoff">
									<i class="material-icons">exit_to_app</i>Efetuar Logoff
								</a>
							</li>
							<li>
								<div class="espacador_menu"></div>
							</li>
						</ul>
					</aside>
				</div>
				<div id="progresso-top" class="progress hide">
					<div class="indeterminate"></div>
				</div>
				<router-view style="overflow: auto;height: 100%;" class="col s12 pa-0" @onCallParent="eventoFilho"
					:usuario="usuario" :dicionario="dicionario" :env="env" :listaAuxiliar="listaAuxiliar" :tema="tema">
				</router-view>
			</div>

			<div id="modal-erro-generico" class="modal modal-fixed-footer">
				<div class="modal-content">
					<h4 id="erro-generico-titulo">...</h4>
					<p id="erro-generico-descricao">...</p>
					<p class="ultra-small" id="erro-generico-detalhe"></p>
				</div>
				<div class="modal-footer">
					<a href="#!" class="modal-action modal-close waves-effect waves-green btn-flat ">Fechar</a>
				</div>
			</div>
		</template>
		<template v-else>
			<catalogo-login 
			v-if="env && !forceLogin && !forceSignin && env.catalogo_login && inModoOndeEncontrar" 
				:tema="tema"
				:env="env" 
				:logo="logo" 
				@goToLogin="goToLogin" 
				@goToSignin="goToSignin" 
			/>

			<pagina-login 
				v-show="!(!forceLogin && !forceSignin && env && env.catalogo_login)"
				ref="paginaLogin" 
				:logo="logologin" 
				:background="background" 
				:exibirErros="!inModoOndeEncontrar"
				@onLoginSuccess="efetuouLogin" 
			/>
		</template>

		<!-- modal catalogo -->
		<confirm-dialog style="width: 700px;" title="Catálogo PDF" :show="!!showDialogCatalogo"
			:btnConfirm="(emprIdCatalogo && unegIdCatalogo && !mostrarMsgDownloadPdf)"
			:btnCancel="!mostrarMsgDownloadPdf" :centralizedSingleBtn="!(emprIdCatalogo && unegIdCatalogo)"
			:topLoader="topLoader" confirmLabel="Baixar pdf" topBottomFixed @onCancel="fecharModalCatalogo"
			@onConfirm="baixarCatalogo">
			<div class="row ma-0 valign-wrapper" style="height: 100%;" v-if="mostrarMsgDownloadPdf">
				<div class="col s12 pa-0 ma-0 center">
					<i class="material-icons grey-text large">picture_as_pdf</i>
					<h5 class="grey-text">Aguarde download do arquivo PDF!</h5>
				</div>
			</div>
			<div class="row ma-0" v-if="dicionario && !mostrarMsgDownloadPdf">
				<div class="col s12 m6">
					<label for="sl-ordem">Filial</label>
					<select id="sl-ordem" v-model="emprIdCatalogo" class="browser-default solutionSelect">
						<option v-for="(empresa, index) in empresas" :value="empresa.emprId" :key="index">
							{{ empresa.emprRefExterno }} - {{ empresa.emprNome }}</option>
					</select>
				</div>
				<div class="col s12 m6">
					<label for="sl-ordem">Unidade de Neg&oacute;cio</label>
					<select id="sl-ordem" v-model="unegIdCatalogo" class="browser-default solutionSelect">
						<option :value="uneg.unegId" v-for="(uneg, index) in unidadesNegocio" :key="index">
							{{ uneg.unegNome }}
						</option>
					</select>
				</div>
				<div class="col s12 m6">
					<label for="sl-modelo-catalogo">Itens por p&aacute;gina</label>
					<select id="sl-modelo-catalogo" v-model="itensPorPaginaCatalogo" class="browser-default solutionSelect">
						<option value="">Padr&atilde;o</option>
						<option :value="8">8 itens por p&aacute;gina</option>
						<option :value="16">16 itens por p&aacute;gina</option>
						<option :value="32">32 itens por p&aacute;gina</option>
					</select>
				</div>
				<div class="col s12 m6" v-if="dicionario.atributo_1 != '-'">
					<label for="sl-atrib-1">{{ dicionario.atributo_1 }}</label>
					<div id="sl-atrib-1" class="catalogo-multiselect">
						<button type="button" class="catalogo-multiselect-trigger solutionSelect"
							@click="alternarAtributoCatalogo(1)">
							<span>{{ atributoCatalogoLabel(atributo1) }}</span>
							<i class="material-icons">arrow_drop_down</i>
						</button>
						<div v-show="catalogoAtributoAberto === 1" class="catalogo-multiselect-opcoes">
							<div class="catalogo-multiselect-filtro">
								<i class="material-icons">search</i>
								<input type="text" v-model="filtroAtributoCatalogo[1]" placeholder="Filtrar opções">
							</div>
							<label class="catalogo-multiselect-opcao" :class="{ selecionada: atributo1.length === 0 }">
								<input type="checkbox" :checked="atributo1.length === 0" @change="limparAtributoCatalogo('atributo1')">
								<i class="material-icons catalogo-multiselect-check">{{ atributo1.length === 0 ? 'check_box' : 'check_box_outline_blank' }}</i>
								<span>TODAS</span>
							</label>
							<label v-for="val in atributosCatalogoFiltrados(listAtributo1, 1)" :key="val" class="catalogo-multiselect-opcao" :class="{ selecionada: atributo1.includes(val) }">
								<input type="checkbox" :value="val" v-model="atributo1">
								<i class="material-icons catalogo-multiselect-check">{{ atributo1.includes(val) ? 'check_box' : 'check_box_outline_blank' }}</i>
								<span>{{ val }}</span>
							</label>
						</div>
					</div>
				</div>
				<div class="col s12 m6" v-if="dicionario.atributo_2 != '-'">
					<label for="sl-atrib-2">{{ dicionario.atributo_2 }}</label>
					<div id="sl-atrib-2" class="catalogo-multiselect">
						<button type="button" class="catalogo-multiselect-trigger solutionSelect" @click="alternarAtributoCatalogo(2)">
							<span>{{ atributoCatalogoLabel(atributo2) }}</span><i class="material-icons">arrow_drop_down</i>
						</button>
						<div v-show="catalogoAtributoAberto === 2" class="catalogo-multiselect-opcoes">
							<div class="catalogo-multiselect-filtro"><i class="material-icons">search</i><input type="text" v-model="filtroAtributoCatalogo[2]" placeholder="Filtrar opções"></div>
							<label class="catalogo-multiselect-opcao" :class="{ selecionada: atributo2.length === 0 }"><input type="checkbox" :checked="atributo2.length === 0" @change="limparAtributoCatalogo('atributo2')"><i class="material-icons catalogo-multiselect-check">{{ atributo2.length === 0 ? 'check_box' : 'check_box_outline_blank' }}</i><span>TODAS</span></label>
							<label v-for="val in atributosCatalogoFiltrados(listAtributo2, 2)" :key="val" class="catalogo-multiselect-opcao" :class="{ selecionada: atributo2.includes(val) }"><input type="checkbox" :value="val" v-model="atributo2"><i class="material-icons catalogo-multiselect-check">{{ atributo2.includes(val) ? 'check_box' : 'check_box_outline_blank' }}</i><span>{{ val }}</span></label>
						</div>
					</div>
				</div>
				<div class="col s12 m6" v-if="dicionario.atributo_3 != '-'">
					<label for="sl-atrib-3">{{ dicionario.atributo_3 }}</label>
					<div id="sl-atrib-3" class="catalogo-multiselect">
						<button type="button" class="catalogo-multiselect-trigger solutionSelect" @click="alternarAtributoCatalogo(3)">
							<span>{{ atributoCatalogoLabel(atributo3) }}</span><i class="material-icons">arrow_drop_down</i>
						</button>
						<div v-show="catalogoAtributoAberto === 3" class="catalogo-multiselect-opcoes">
							<div class="catalogo-multiselect-filtro"><i class="material-icons">search</i><input type="text" v-model="filtroAtributoCatalogo[3]" placeholder="Filtrar opções"></div>
							<label class="catalogo-multiselect-opcao" :class="{ selecionada: atributo3.length === 0 }"><input type="checkbox" :checked="atributo3.length === 0" @change="limparAtributoCatalogo('atributo3')"><i class="material-icons catalogo-multiselect-check">{{ atributo3.length === 0 ? 'check_box' : 'check_box_outline_blank' }}</i><span>TODAS</span></label>
							<label v-for="val in atributosCatalogoFiltrados(listAtributo3, 3)" :key="val" class="catalogo-multiselect-opcao" :class="{ selecionada: atributo3.includes(val) }"><input type="checkbox" :value="val" v-model="atributo3"><i class="material-icons catalogo-multiselect-check">{{ atributo3.includes(val) ? 'check_box' : 'check_box_outline_blank' }}</i><span>{{ val }}</span></label>
						</div>
					</div>
				</div>
				<div class="col s12 m6" v-if="dicionario.atributo_4 != '-'">
					<label for="sl-atrib-4">{{ dicionario.atributo_4 }}</label>
					<div id="sl-atrib-4" class="catalogo-multiselect">
						<button type="button" class="catalogo-multiselect-trigger solutionSelect" @click="alternarAtributoCatalogo(4)">
							<span>{{ atributoCatalogoLabel(atributo4) }}</span><i class="material-icons">arrow_drop_down</i>
						</button>
						<div v-show="catalogoAtributoAberto === 4" class="catalogo-multiselect-opcoes">
							<div class="catalogo-multiselect-filtro"><i class="material-icons">search</i><input type="text" v-model="filtroAtributoCatalogo[4]" placeholder="Filtrar opções"></div>
							<label class="catalogo-multiselect-opcao" :class="{ selecionada: atributo4.length === 0 }"><input type="checkbox" :checked="atributo4.length === 0" @change="limparAtributoCatalogo('atributo4')"><i class="material-icons catalogo-multiselect-check">{{ atributo4.length === 0 ? 'check_box' : 'check_box_outline_blank' }}</i><span>TODAS</span></label>
							<label v-for="val in atributosCatalogoFiltrados(listAtributo4, 4)" :key="val" class="catalogo-multiselect-opcao" :class="{ selecionada: atributo4.includes(val) }"><input type="checkbox" :value="val" v-model="atributo4"><i class="material-icons catalogo-multiselect-check">{{ atributo4.includes(val) ? 'check_box' : 'check_box_outline_blank' }}</i><span>{{ val }}</span></label>
						</div>
					</div>
				</div>
				<div class="col s12 m6" v-if="dicionario.atributo_6 && dicionario.atributo_6 != '-'">
					<label for="sl-atrib-6">{{ dicionario.atributo_6 }}</label>
					<div id="sl-atrib-6" class="catalogo-multiselect">
						<button type="button" class="catalogo-multiselect-trigger solutionSelect" @click="alternarAtributoCatalogo(6)">
							<span>{{ atributoCatalogoLabel(atributo6) }}</span><i class="material-icons">arrow_drop_down</i>
						</button>
						<div v-show="catalogoAtributoAberto === 6" class="catalogo-multiselect-opcoes">
							<div class="catalogo-multiselect-filtro"><i class="material-icons">search</i><input type="text" v-model="filtroAtributoCatalogo[6]" placeholder="Filtrar opções"></div>
							<label class="catalogo-multiselect-opcao" :class="{ selecionada: atributo6.length === 0 }"><input type="checkbox" :checked="atributo6.length === 0" @change="limparAtributoCatalogo('atributo6')"><i class="material-icons catalogo-multiselect-check">{{ atributo6.length === 0 ? 'check_box' : 'check_box_outline_blank' }}</i><span>TODAS</span></label>
							<label v-for="val in atributosCatalogoFiltrados(listAtributo6, 6)" :key="val" class="catalogo-multiselect-opcao" :class="{ selecionada: atributo6.includes(val) }"><input type="checkbox" :value="val" v-model="atributo6"><i class="material-icons catalogo-multiselect-check">{{ atributo6.includes(val) ? 'check_box' : 'check_box_outline_blank' }}</i><span>{{ val }}</span></label>
						</div>
					</div>
				</div>
				<div class="input-field col s12 m6">
					<input id="catalogo-descricao" type="text" v-model="descricaoCatalogo">
					<label for="catalogo-descricao">Descri&ccedil;&atilde;o</label>
				</div>
				<div class="input-field col s12 m6">
					<input id="catalogo-aplicacao" type="text" v-model="aplicacaoCatalogo">
					<label for="catalogo-aplicacao">Aplica&ccedil;&atilde;o</label>
				</div>
				<div class="col s12">
					<div class="grey lighten-4 grey-text text-darken-2 pa-1 mt-1">
						<template v-if="!emprIdCatalogo || !unegIdCatalogo">
							Selecione filial e unidade de neg&oacute;cio para visualizar a quantidade de itens.
						</template>
						<template v-else-if="carregandoQuantidadeCatalogo">
							Calculando quantidade de itens...
						</template>
						<template v-else-if="quantidadeItensCatalogo !== null">
							<div>
								{{ quantidadeItensCatalogo }} {{ quantidadeItensCatalogo === 1 ? 'item será apresentado' : 'itens serão apresentados' }} no cat&aacute;logo.
							</div>
							<div v-if="quantidadePaginasCatalogo !== null">
								Estimativa: {{ quantidadePaginasCatalogo }}
								{{ quantidadePaginasCatalogo === 1 ? 'página' : 'páginas' }}
								(incluindo a capa, {{ itensPorPaginaModeloCatalogo }} itens por p&aacute;gina).
							</div>
						</template>
					</div>
				</div>
			</div>
		</confirm-dialog>

		<simple-dialog style="width: 40%;" :show="showDialogAniversariante" @onClose="showDialogAniversariante = false"
			:dismissible="false">
			<div class="row ma-0">
				<div class="col s12 pa-0">
					<img :src="imgArteAniversario" class="materialboxed card ma-0 mb-1" ref="materialboxed"
						style="width: 100%">
					<span class="ultra-small grey-text">Clique na imagem para ampli&aacute;-la</span>
				</div>
			</div>
		</simple-dialog>

		<simple-dialog style="width: 40%;" :show="showDialogAuthorizationBling"
			@onClose="showDialogAuthorizationBling = false" :dismissible="false">
			<div class="row ma-0">
				<div class="col s12 pa-0">
					<h4>Para continuar com a integra&ccedil;&atilde;o Bling! Por favor efetue o login ou cadastre-se!
					</h4>
				</div>
			</div>
		</simple-dialog>

		<div class="fixed-action-btn whatsApp" @click.prevent="abrirNovaAbaWhatsApp" v-if="!estaLogado && !inModoOndeEncontrar && !inModoCatalogoPublico">
			<a class="tooltipped" data-position="left" data-tooltip="Fale conosco no WhatsApp">
				<img src="./assets/whatsapp.png" width="60">
			</a>
		</div>

		<simple-dialog style="width: 50%;" :show="showVideoAjuda" @onClose="showVideoAjuda = false"
			:dismissible="false">
			<div class="row ma-0">
				<div class="col s12 pa-1">
					<iframe :src="urlVideoAjuda" width="640" height="480" allow="autoplay"></iframe>
				</div>
			</div>
		</simple-dialog>

		<!-- modal confirmar generico -->
		<confirm-sim-nao-dialog ref="confirmaSimNao" class="black-text" />
	</div>
</template>

<script>
import PaginaLogin from './components/shared/PaginaLogin/PaginaLogin.vue';
import ServiceFactory from './components/services/ServiceFactory';
import StHelper from './components/helpers/StHelper';
import VueCustomRegisterer from './components/helpers/VueCustomRegisterer';
import ErrorDialog from './components/shared/errorDialog/ErrorDialog.vue';
import SimpleDialog from './components/shared/dialog/SimpleDialog.vue';
import ConfirmDialog from './components/shared/dialog/ConfirmDialog.vue';
import ShowContentHelper from './components/helpers/ShowContentHelper';
import TopLoader from './components/shared/topLoader/TopLoader.vue';
import CarrinhoView from './components/shared/carrinhoView/CarrinhoView.vue';
import ConfirmSimNaoDialog from "./components/shared/dialog/ConfirmSimNaoDialog.vue";
import CatalogoLogin from './components/shared/CatalogoLogin/CatalogoLogin.vue';
import OndeEncontrar from './components/shared/viewer/OndeEncontrar.vue';
import Unit050 from './components/units/Unit050.vue';
import B2bChat from './components/shared/chat/B2bChat.vue';


import * as moment from 'moment';
import 'moment/locale/pt-br';
moment.locale('pt-BR');

new VueCustomRegisterer(); // o construtor registra o validador/filtros globalmente

export default {
	components: {
		B2bChat,
		PaginaLogin, ErrorDialog, SimpleDialog, ConfirmDialog, TopLoader, CarrinhoView, ConfirmSimNaoDialog, CatalogoLogin, OndeEncontrar, Unit050,
	},
	data() {
		return {
			serviceFactory: null,
			usuarioService: null,
			loginService: null,
			carrinhoService: null,
			unegService: null,
			publicacaoService: null,
			menuService: null,
			roleService: null,
			auth: {},
			nomeEmpresa: 'Logo',
			logo: null,
			logologin: null,
			background: null,
			imagemUsuario: '',
			temaMto: false,
			estaLogado: false,
			quantidadeDetalhes: null,
			modalError: null,
			usuario: null,
			dicionario: null,
			clienteSelecionado: null,
			url: null,
			isNovaPublicacao: false,
			idIntervalo: null,
			idCheckSessao: null,
			idCheckCobrancaEletronica: null,
			caminhoApk: 'webapi/app/download/android/release',
			envService: null,
			env: null,
			showDialogAniversariante: false,
			imgArteAniversario: null,
			quantidadePublicacoesNaoLidas: 0,
			itensSelecionados: false,
			menuExibir: [],
			menuExibirFlatMap: [],
			qtdCoelAbertas: null,
			qtdItemSemCadAdicionais: 0,
			coelService: null,
			itemCadastroService: null,
			listaAuxiliar: [],
			tema: null,
			dicionarioService: null,
			clienteService: null,
			sch: new ShowContentHelper(),
			planilhaItensService: null,
			integracaoMarketplaceService: null,
			errorsAuthMarketplace: [],
			showDialogCatalogo: false,
			emprIdCatalogo: null,
			unegIdCatalogo: null,
			itensPorPaginaCatalogo: '',
			empresas: null,
			unidadesNegocio: null,
			showDialogAuthorizationBling: false,
			showVideoAjuda: false,
			atributoService: null,
			listAtributo1: [],
			listAtributo2: [],
			listAtributo3: [],
			listAtributo4: [],
			listAtributo6: [],
			atributo1: [],
			atributo2: [],
			atributo3: [],
			atributo4: [],
			atributo6: [],
			catalogoAtributoAberto: null,
			filtroAtributoCatalogo: { 1: '', 2: '', 3: '', 4: '', 6: '' },
			descricaoCatalogo: '',
			aplicacaoCatalogo: '',
			quantidadeItensCatalogo: null,
			carregandoQuantidadeCatalogo: false,
			catalogoQuantidadeTimer: null,
			catalogoQuantidadeReqSeq: 0,
			catalogoDadosPromise: null,
			topLoader: [],
			mostrarMsgDownloadPdf: false,
			showCarrinhoView: false,
			forceLogin: false,
			forceSignin: false,
			compraSemLogin: null,
			unegIdCoresAtual: null,
			unegCoresReqSeq: 0,
		}
	},
	mounted() {
		$(this.$refs.materialboxed).materialbox();
	},
	created() {
		this.forceLogin = false;
		this.forceSignin = false;
		this.aplicaCoresDoStorage();
		window.addEventListener("resize", this.infoDispositivo);
		this.serviceFactory = new ServiceFactory(this.$http);
		this.serviceFactory.env()
			.then(serv => serv.obterMapa())
			.then(m => {
				this.env = m;
				if (this.env && this.env.imprime_versao_no_titulo && this.env.app_version) {
					document.title = document.title + ' ' + this.env.app_version;
				};

				this.env.temPerfil = this.temPerfil;
				this.infoDispositivo();
			})
			.then(() => {
				if (this.$router.currentRoute.query.redirectToBling) {
					console.log('Veio do bling!');
					this.showDialogAuthorizationBling = true;

				} else if (this.$router.currentRoute.path == '/') {
					this.vaiParaHome();
				}

				return true;
			})
			.then(() => this.checaVersaoSistemaModou())
			.then(() => this.tema = this.obtemTemaUltimoAcesso())
			.then(() => this.defineImagens())
			.then(() => this.serviceFactory.unidadeNegocio())
			.then(serv => this.unegService = serv)
			.then(() => this.serviceFactory.menu())
			.then(serv => this.menuService = serv)
			.then(() => this.serviceFactory.cobrancaEletronica())
			.then(serv => this.coelService = serv)
			.then(() => this.serviceFactory.integracaoMarketplace())
			.then(serv => this.integracaoMarketplaceService = serv)
			.then(() => this.serviceFactory.itemCadastro())
			.then(serv => this.itemCadastroService = serv)
			.then(() => this.obtemQtdItemSemCadAdicionais())
			.then(() => this.serviceFactory.planilhaItens())
			.then(serv => this.planilhaItensService = serv)
			.then(() => this.checkIfCookiesIsEnabled())
			.then(() => this.serviceFactory.atributo())
			.then(serv => this.atributoService = serv)
			.catch(e => this.modalError = e);

	},
	updated() {
		$('.tooltipped').tooltip({ delay: 50 });
		$(this.$refs.botaoMenu).sideNav('destroy');
		$(this.$refs.botaoMenu).sideNav({
			draggable: true
		});
		//gambi para resolver problema em telas pequenas
		$('.side-nav li a').on('click', (e) => {
			let windowsize = $(window).width();
			if (windowsize < 1024) {
				setTimeout(() => {
					$(this.$refs.botaoMenu).sideNav('hide');
				}, 300);
			}
		});
		this.infoDispositivo();
	},
	beforeDestroy() {
		clearInterval(this.idIntervalo);
		clearInterval(this.idCheckSessao);
		clearInterval(this.idCheckCobrancaEletronica);
		clearTimeout(this.catalogoQuantidadeTimer);
		window.removeEventListener("resize", this.infoDispositivo);
	},
	computed: {
		/**
		 * validação para mostrar item de menu para download da planilha de itens
		 * @since 1.20.01
		 * @author Amaro Silva
		 */
		mostrarlink() {
			const admin = this.env && this.env.temPerfil(this.usuario.usuaRole, ['ADMIN', 'ROOT']);
			const config = this.env && this.env['lista_item.nome_arquivo_csv_exportar'];
			const loadList = this.menuExibir && this.menuExibir.length > 0;

			return admin && config && loadList;
		},
		urlVideoAjuda() {
			const url = `${this.$route.name}_url_video_ajuda`;
			if (!(this.env && this.env[url] && this.env[url].length > 0)) return null;
			return this.env[url];
		},
		existeMenuCarrinho() {
			return this.menuExibir.find(m => m.itens.find(i => i.unit == 'unit_carrinho'))
		},
		inModoCarrinho: function () {
			return StHelper.usaCarrinhoSeparado(this.usuario);
		},
		inModoOndeEncontrar: function () {
			return this.$route.query.ondeEncontrar;
		},
		inModoCatalogoPublico: function () {
			return String(this.$route.query.catalogo).toLowerCase() === 'true';
		},
		usuarioCatalogoPublico: function () {
			return {
				usuaRole: 'CATALOGO',
				usuaIdUneg: Number(this.$route.query['id-categoria'] || this.$route.query.unegId || 1)
			};
		},
		dicionarioCatalogoPublico: function () {
			return {
				item_codigo: 'Código', item_ref_externo: 'Referência', item_sku_fabricante: 'SKU',
				atributo_1: 'Marca', atributo_2: 'Montadora', atributo_3: 'Grupo',
				atributo_4: 'Categoria', atributo_6: 'Aplicação'
			};
		},
		itensPorPaginaModeloCatalogo() {
			return Number(this.itensPorPaginaCatalogo) || 32;
		},
		quantidadePaginasCatalogo() {
			if (this.quantidadeItensCatalogo === null) return null;
			if (this.quantidadeItensCatalogo === 0) return 0;

			const paginasDeItens = Math.ceil(
				this.quantidadeItensCatalogo / this.itensPorPaginaModeloCatalogo
			);
			return paginasDeItens + 1;
		}
	},
	watch: {
		clienteSelecionado: function (nv) {
			this.$set(this.usuario, 'clienteSelecionado', nv);
			this.remontaMenu().catch(e => this.modalError = e);
		},
		quantidadeDetalhes: function (nv) {
			//   this.$refs.CarrinhoView.getSubtotal();
		},
		$route: function (nv) {
			this.showCarrinhoView = false;
		},
		showDialogCatalogo: function (nv) {
			if (nv) {
				this.carregarDadosCatalogo()
					.then(() => this.agendarAtualizacaoQuantidadeCatalogo())
					.catch(e => this.modalError = e);
			}
		},
		emprIdCatalogo: function () {
			this.carregarAtributosCatalogo().catch(e => this.modalError = e);
			this.agendarAtualizacaoQuantidadeCatalogo();
		},
		unegIdCatalogo: function () {
			this.agendarAtualizacaoQuantidadeCatalogo();
		},
		atributo1: function () {
			this.agendarAtualizacaoQuantidadeCatalogo();
		},
		atributo2: function () {
			this.agendarAtualizacaoQuantidadeCatalogo();
		},
		atributo3: function () {
			this.agendarAtualizacaoQuantidadeCatalogo();
		},
		atributo4: function () {
			this.agendarAtualizacaoQuantidadeCatalogo();
		},
		atributo6: function () {
			this.agendarAtualizacaoQuantidadeCatalogo();
		},
		descricaoCatalogo: function () {
			this.agendarAtualizacaoQuantidadeCatalogo();
		},
		aplicacaoCatalogo: function () {
			this.agendarAtualizacaoQuantidadeCatalogo();
		},
	},
	methods: {
		goToLogin(produto) {
			this.forceLogin = true;
			if(!this.compraSemLogin && produto && produto.sku) this.compraSemLogin = produto.sku;
		},
		goToSignin() {
			this.forceSignin = true;
			this.$nextTick()
			.then(() => this.$refs.paginaLogin.queroAcessar());
		},
		openSideViewKart() {
			Promise.resolve()
			.then(() => this.obterUsuario())
			.then(() => {
				if (!this.quantidadeDetalhes || this.quantidadeDetalhes == 0)
				return this.$router.push({ path: 'unit039' });

				this.showCarrinhoView = !this.showCarrinhoView;

				if (this.showCarrinhoView) {
					console.log('Open side view kart')
					this.$refs.CarrinhoView && this.$refs.CarrinhoView.getSubtotal();
				}
			})
			.catch(e => this.modalError = e);
			
		},
		getMsgIconCarrinho() {
			if (this.$route.name == 'unit039' || !this.quantidadeDetalhes || this.quantidadeDetalhes == 0) return 'Ver Carrinho';
			return this.showCarrinhoView ? 'Fechar Resumo' : 'Abrir Resumo'
		},
		checkIfCookiesIsEnabled() {
			if (!navigator.cookieEnabled) {
				StHelper.toastAlertaNegative('A gravação de cookies está desabilitada no seu navagador! Habilite a gravação de cookies para este site para evitar problemas de mau funcionamento.');
			} else {
				console.log('👍 Cookies habilitados!');

				if (document.cookie.includes('B2B_TOKEN')) {
					console.log('🍪 Cookies saudáveis!');
				} else {
					console.log('😞 Sem cookies para você hoje.');
				}
			}
		},
		vaiParaHome() {
			if (this.usuario && this.usuario.usuaRole == 'MARKETING') {
				const primeiroGrupo = this.menuExibir && this.menuExibir.find(grupo => grupo.itens && grupo.itens.length);
				const primeiroCaminho = primeiroGrupo && primeiroGrupo.itens[0].path;
				if (primeiroCaminho) this.$router.push(primeiroCaminho);
				return;
			}
			this.$router.push(this.env.home);
		},
		eventoFilho(id, params) {
			if (id == 'selecionarCliente') {
				this.clienteSelecionado = params;
			} else if (id == 'obterUsuario') {
				this.obterUsuario(params);
			} else if (id == 'alterarQuantidadeDetalhes') {
				console.log('eventoFilho', id, params);
				this.defineQtd(params)
			} else if (id == 'alterarImagemAvatarSideBar') {
				this.buscaImgAvatar();
			} else if (id == 'showContagem') {
				this.itensSelecionados = params;
			} else if (id == 'alterarQuantidadeCoelAbertas') {
				this.notificaQtdCoelAbertas();
			} else if (id == 'alterarQuantidadeCoelPorCarteira') {
				this.notificaQtdCoelAbertasPorCarteira();
			} else if (id == 'alteraClienteSelecionado') {
				this.atualizaClienteSelecioado(params);
			} else if (id == 'alterarQuantidadePublicacoesNaoLidas') {
				this.quantidadePublicacoesNaoLidas = params;
				this.remontaMenu()
					.catch(e => this.modalError = e);
			} else if (id == 'adicionarNoPedido') {
				this.listaAuxiliar = params;
				this.$router.push('unit005?addEmLote=true')
			} else if (id == 'limparListaAuxiliar') {
				this.listaAuxiliar = [];
			} else if (id == 'alterarQtdItemSemCadAdicionais') {
				this.obtemQtdItemSemCadAdicionais();
			} else if (id == 'onOpenSideViewKart') {
				this.openSideViewKart();
			} else if (id == 'onError') {
				this.modalError = params;
			}
		},
		remontaMenu() {
			if (this.menuService) {
				return this.menuService.obtem(this.env, this.usuario, this.usuario.clienteSelecionado, this.quantidadePublicacoesNaoLidas)
					.then(menu => this.menuExibir = menu)
					.then(() => { // redireciona tela caso tenha apenas uma opção de menu
						const primeiroGrupo = this.menuExibir.find(grupo => grupo.itens && grupo.itens.length);
						const emRotaHome = ['/', '/homeB', '/homeE', '/homeD'].includes(this.$route.path);
						const redirecionarMarketing = this.usuario.usuaRole == 'MARKETING' && emRotaHome;
						const path = (this.menuExibir.length == 1 || redirecionarMarketing) && primeiroGrupo && primeiroGrupo.itens[0].path;
						if (path && path.trim().length > 0) this.$router.push(path);
					})
					.then(() => this.listAuthenticationErrors());
			} else {
				return Promise.resolve();
			}
		},
		efetuouLogin(auth) {
			console.log('efetuouLogin', auth);
			this.estaLogado = true;
			this.auth = auth;
			this.usuario = this.auth.stUsuario;
			this.checaVersaoSistemaModou();
			if (this.usuario && this.usuario.usuaIdUneg) {
				this.defineUnegIdCores(this.usuario.usuaIdUneg);
				this.aplicaCoresPorUnegId(this.usuario.usuaIdUneg);
			}
			const { usuaRole } = this.usuario || '';
			const isAdmin = usuaRole == 'ADMIN' || usuaRole == 'ROOT';
			const podeGerarCatalogo = isAdmin || ['COMPRAS', 'MARKETING'].includes(usuaRole);
			if (isAdmin) {
				window.localStorage.setItem('PWA_B2B_TOKEN', window.localStorage.getItem('B2B_TOKEN'));
				this.serviceFactory.unidadeNegocio()
					.then(serv => this.unegService = serv)
					.then(() => this.unegService.getById(this.usuario.usuaIdUneg))
					.then(uneg => {
						if (uneg) {
							this.selecionaTema(uneg.unegTema)
							this.defineTituloSite(uneg.unegTituloSite)
							if (this.unegIdCoresAtual && uneg.unegId === this.unegIdCoresAtual) {
								this.aplicaCoresDinamicas({
									paraCorPrimaria: uneg.unegCorPrimaria,
									paraCorSecundaria: uneg.unegCorSecundaria
								});
							}
						}

						return true;
					})
					.then(() => this.obtemQtdItemSemCadAdicionais())
					.then(() => this.carregarDadosCatalogo())
					.catch(e => this.modalError = e);
			} else {
				if(this.compraSemLogin) this.$router.push({path:'unit004', query:{semLogin: true, sku:this.compraSemLogin}});
			}

			if (podeGerarCatalogo && !isAdmin) {
				this.carregarDadosCatalogo()
					.catch(e => this.modalError = e);
			}

			this.serviceFactory.dicionario()
				.then(diciService => diciService.get())
				.then(bean => this.dicionario = bean)
				.catch(e => this.modalError = e);

			this.serviceFactory.usuario()
				.then(serv => this.usuarioService = serv)
				.then(() => this.serviceFactory.login())
				.then(serv => this.loginService = serv)
				.then(() => this.serviceFactory.carrinho())
				.then(serv => this.carrinhoService = serv)
				.then(() => this.serviceFactory.publicacao())
				.then(serv => this.publicacaoService = serv)
				.then(() => this.serviceFactory.role())
				.then(serv => this.roleService = serv)
				.then(() => {
					if (this.roleService.visualizaPublicacao(this.usuario.usuaRole)) {
						return this.publicacaoService.getListaPublicacoesNaoVisualizadasByUser();
					} else {
						return new Promise((resolve, reject) => resolve([]));
					}
				})
				.then(list => this.quantidadePublicacoesNaoLidas = list.length)
				.then(() => {
					if (this.usuario.usuaEmail.includes('@solutiontrue.com.br')) {
						this.caminhoApk = 'webapi/app/android/debug';
					}
					if (!isAdmin && this.roleService.possuiClienteSelecionado(this.usuario.usuaRole)) {
						this.serviceFactory.cliente()
							.then(clienteService => {
								this.usuarioService.obtemClienteSelecionado()
									.then(clieId => clieId ? clienteService.get(clieId) : Promise.resolve(null))
									.then(clie => {
										if (clie) {
											this.clienteSelecionado = clie;
											this.selecionaTema(clie.unidadeNegocio.unegTema);
											if (this.usuario && this.usuario.usuaIdUneg) {
												this.defineUnegIdCores(this.usuario.usuaIdUneg);
												this.aplicaCoresPorUnegId(this.usuario.usuaIdUneg);
											} else {
												this.aplicaCoresDinamicas({
													paraCorPrimaria: clie.unidadeNegocio && clie.unidadeNegocio.unegCorPrimaria,
													paraCorSecundaria: clie.unidadeNegocio && clie.unidadeNegocio.unegCorSecundaria
												});
											}
											let tituloSite = clie && clie.unidadeNegocio && clie.unidadeNegocio.unegTituloSite;
											this.defineTituloSite(tituloSite);
											this.obtemQuantidadeDetalhes();
											this.notificaQtdCoelAbertas();
										} else {
											this.unegService.getById(this.usuario.usuaIdUneg)
												.then(uneg => {
													if (uneg) {
														this.selecionaTema(uneg.unegTema);
														if (uneg.unegTituloSite) this.defineTituloSite(uneg.unegTituloSite);
														this.aplicaCoresDinamicas({
															paraCorPrimaria: uneg.unegCorPrimaria,
															paraCorSecundaria: uneg.unegCorSecundaria
														});
													}
													return uneg;
												})
												.then(() => {
													this.clienteSelecionado = null;
													this.$router.push(this.env.unit_clientes); //redireciona para selecao de cliente
													Materialize.toast('Não há cliente selecionado. Você foi redirecionado para a seleção.', 4000);
												})
												.catch(e => this.modalError = e);
										}
										this.verificaEExibeImagemDeAniversario();
										if (this.quantidadePublicacoesNaoLidas > 0) this.$router.push(this.env.unit_publicacoes);
									})
									.catch(e => this.modalError = e);
							})
							.catch(e => this.modalError = e);
					}
					this.buscaImgAvatar();
					if (this.roleService.visualizaPublicacao(this.usuario.usuaRole)) {
						this.checkNovaPublicacao();
						this.idIntervalo = setInterval(() => this.checkNovaPublicacao(), 1000 * 60 * 30);
					}
					this.obtemLinkCanalDireto();
					this.idCheckSessao = setInterval(() => {
						this.loginService.manterSessaoViva(this.usuario.usuaId).catch(err => console.error(err))
					}, 1000 * 60)

					this.idCheckCobrancaEletronica = setInterval(() => {
						this.notificaQtdCoelAbertas();
					}, 300000 * 60)
				})
				.then(() => this.remontaMenu())
				.catch(e => this.modalError = e);
		},
		// Função auxiliar para clarear cor
		lightenColor(color, percent) {
			const num = parseInt(color.replace("#",""), 16);
			const amt = Math.round(2.55 * percent);
			const R = (num >> 16) + amt;
			const G = (num >> 8 & 0x00FF) + amt;
			const B = (num & 0x0000FF) + amt;
			return "#" + (0x1000000 + (R<255?R<1?0:R:255)*0x10000 +
				(G<255?G<1?0:G:255)*0x100 +
				(B<255?B<1?0:B:255))
				.toString(16).slice(1);
		},

		// Função auxiliar para escurecer cor
		darkenColor(color, percent) {
			const num = parseInt(color.replace("#",""), 16);
			const amt = Math.round(2.55 * percent);
			const R = (num >> 16) - amt;
			const G = (num >> 8 & 0x00FF) - amt;
			const B = (num & 0x0000FF) - amt;
			return "#" + (0x1000000 + (R>0?R:0)*0x10000 +
				(G>0?G:0)*0x100 +
				(B>0?B:0))
				.toString(16).slice(1);
		},
		aplicaCoresDoStorage() {
			const primaryColor = window.localStorage.getItem('B2B_TEMA_COR_PRIMARIA');
			const secondaryColor = window.localStorage.getItem('B2B_TEMA_COR_SECUNDARIA');
			this.aplicaCoresDinamicas({ paraCorPrimaria: primaryColor, paraCorSecundaria: secondaryColor }, false);
		},
		aplicaCoresDinamicas(param = {}, atualizarStorage = true) {
			if (!param) return;
			const primaryColor = (param.paraCorPrimaria || '').toString().trim();
			const secondaryColor = (param.paraCorSecundaria || '').toString().trim();
			console.log('Aplicando cores configuradas', primaryColor, secondaryColor);
			if (primaryColor) {
				document.documentElement.style.setProperty('--primary-color', primaryColor);
				document.documentElement.style.setProperty('--primary-color-light', this.lightenColor(primaryColor, 15));
				document.documentElement.style.setProperty('--primary-color-dark', this.darkenColor(primaryColor, 15));
				if (atualizarStorage) window.localStorage.setItem('B2B_TEMA_COR_PRIMARIA', primaryColor);
			} else {
				document.documentElement.style.removeProperty('--primary-color');
				document.documentElement.style.removeProperty('--primary-color-light');
				document.documentElement.style.removeProperty('--primary-color-dark');
				if (atualizarStorage) window.localStorage.removeItem('B2B_TEMA_COR_PRIMARIA');
			}
			if (secondaryColor) {
				document.documentElement.style.setProperty('--secondary-color', secondaryColor);
				document.documentElement.style.setProperty('--secondary-color-dark', this.darkenColor(secondaryColor, 10));
				if (atualizarStorage) window.localStorage.setItem('B2B_TEMA_COR_SECUNDARIA', secondaryColor);
			} else {
				document.documentElement.style.removeProperty('--secondary-color');
				document.documentElement.style.removeProperty('--secondary-color-dark');
				if (atualizarStorage) window.localStorage.removeItem('B2B_TEMA_COR_SECUNDARIA');
			}
		},
		defineUnegIdCores(unegId) {
			this.unegIdCoresAtual = unegId || null;
		},
		aplicaCoresPorUnegId(unegId) {
			if (!unegId) return;
			const reqSeq = ++this.unegCoresReqSeq;
			const unegIdAlvo = unegId;
			const carregaUneg = this.unegService
				? Promise.resolve(this.unegService)
				: this.serviceFactory.unidadeNegocio().then(serv => this.unegService = serv);
			carregaUneg
				.then(() => this.unegService.getById(unegId))
				.then(uneg => {
					if (reqSeq !== this.unegCoresReqSeq) return;
					if (this.unegIdCoresAtual && unegIdAlvo !== this.unegIdCoresAtual) return;
					if (uneg) {
						this.aplicaCoresDinamicas({
							paraCorPrimaria: uneg.unegCorPrimaria,
							paraCorSecundaria: uneg.unegCorSecundaria
						});
					}
				})
				.catch(e => console.error('Erro ao carregar cores por unidade de negócio:', e));
		},
		verificaEExibeImagemDeAniversario() {
			if (this.clienteSelecionado && this.clienteSelecionado.clieDtNascimento) {
				this.unegService.getById(this.usuario.usuaIdUneg)
					.then(uneg => {
						if (uneg && uneg.unegInArteAnivHabilitada) {
							if (this.roleService.exibeArteAniversario(this.usuario.usuaRole, this.clienteSelecionado.clieDtNascimento)) {
								//aqui é o lugar
								this.unegService.obtemArteAniversario(this.usuario.usuaIdUneg)
									.then(textImg => this.imgArteAniversario = textImg)
									.then(() => {
										if (this.imgArteAniversario) {
											this.showDialogAniversariante = true
										}
									})
									.catch(err => this.modalError = err);
							}
						}
					})
					.catch(err => this.modalError = err);
			}
		},
		obtemLinkCanalDireto() {
			if (this.usuario.usuaIdUneg && this.roleService.veLinkCanalDireto(this.usuario.usuaRole)) {
				this.serviceFactory.unidadeNegocio()
					.then(serv => this.unegService = serv)
					.then(() => this.unegService.getById(this.usuario.usuaIdUneg)
						.then(uneg => this.url = uneg.unegCanalDiretoUrl)
					)
					.catch(err => this.modalError = err);
			}
		},
		showMsgDemo() {
			Materialize.toast('Não disponível na Demo');
		},
		obtemQuantidadeDetalhes() {
			this.usuarioService.obtemIdPedidoAberto()
				.then(pedcId => {
					if (pedcId) {
						this.carrinhoService.obtemQuantidadeDetalhesSemFalta(pedcId)
							.then(qtd => this.quantidadeDetalhes = qtd)
							.catch(e => this.modalError = e);
					}
				})
				.catch(e => this.modalError = e);
		},

		/**
		 * Obtem a quantidade de itens que ainda faltam cadastrar dados adicionais
		 */
		obtemQtdItemSemCadAdicionais() {
			if (!['SAC', 'DEVOLUCAO', 'FINANCEIRO'].includes(this.usuario && this.usuario.usuaRole)) return;
			if (this.itemCadastroService) {
				this.itemCadastroService.obterQuantidadeItemSemDadosCadastraisAdicionais()
					.then(qtd => this.qtdItemSemCadAdicionais = qtd)
					.catch(e => this.modalerror = e)
			}
		},

		efetuarLogoff() {
			this.loginService.efetuarLogoff(this.usuario.usuaId)
				.then(() => {
					this.estaLogado = false;
					this.forceSignin = false;
					this.vaiParaHome();
					this.clienteSelecionado = null;
					clearInterval(this.idIntervalo);
					clearInterval(this.idCheckSessao);
					clearInterval(this.idCheckCobrancaEletronica);
					this.quantidadeDetalhes = null;
				})
				.catch(e => {
					console.error(e);
				});
		},
		findGetParameter(parameterName) {
			let result = null,
				tmp = [];
			location.search
				.substr(1)
				.split("&")
				.forEach(function (item) {
					tmp = item.split("=");
					if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
				});
			return result;
		},
		buscaImgAvatar() {
			this.usuarioService.obtemImagemAvatar()
				.then((image) => {
					if (image) this.imagemUsuario = image;
					else this.imagemUsuario = './webapi/resource/abstract-identity.jpg';
				})
				.catch((error) => {
					this.modalError = error;
				});
		},
		checkNovaPublicacao() {
			this.publicacaoService.obtemDataUltimaPublicacao()
				.then(dtUltPubl => {
					if (!this.usuario.usuaDthhUltimoCheck) this.usuario.usuaDthhUltimoCheck = new Date(0);
					this.isNovaPublicacao = moment.default(dtUltPubl).isAfter(moment.default(this.usuario.usuaDthhUltimoCheck));
					this.usuarioService.updateLastCheckNovaPublicacao()
						.then(dtLastCheck => this.usuario.usuaDthhUltimoCheck = dtLastCheck)
						.catch(err => this.modalError = err);
				})
				.catch(err => this.modalError = err);
		},
		abrirNovaAbaWhatsApp() {
			const contatoWhatsapp = this.obterContatoWhatsapp();
			if (!contatoWhatsapp) return;

			window.open(`https://api.whatsapp.com/send?phone=${contatoWhatsapp}&text=&source=&data=&app_absent=`, '_blank');
		},
		obterContatoWhatsapp() {
			if (!this.env) return null;

			const empresa = this.obterEmpresaContatoWhatsapp();
			const keys = [];

			if (empresa && empresa.emprId) keys.push(`contato_whatsapp_${empresa.emprId}`);
			if (empresa && empresa.emprRefExterno) keys.push(`contato_whatsapp_${empresa.emprRefExterno}`);
			keys.push('contato_whatsapp');

			const key = keys.find(k => this.env[k]);
			return key ? this.env[key] : null;
		},
		obterEmpresaContatoWhatsapp() {
			if (this.clienteSelecionado && this.clienteSelecionado.empresa) return this.clienteSelecionado.empresa;
			if (this.usuario && this.usuario.clienteSelecionado && this.usuario.clienteSelecionado.empresa) {
				return this.usuario.clienteSelecionado.empresa;
			}
			if (this.usuario && this.usuario.empresa) return this.usuario.empresa;
			return null;
		},

		/**
		* atualiza quantidade de cobrancas eletronicas abertas no menu
		* @since 1.8.83
		* @author Amaro Silva
		*/
		notificaQtdCoelAbertas() {
			if (this.usuario.usuaIdClieSelec && this.coelService) {
				this.coelService.obterQtdCoelAbertas(this.usuario.usuaIdClieSelec)
					.then(coelAbertoRes => this.qtdCoelAbertas = coelAbertoRes)
					.catch(e => this.modalerror = e)
			}
		},

		/**
		* atualiza quantidade de cobrancas eletronicas abertas no menu por carteira
		* @since 1.10.0
		* @author Amaro Silva
		*/
		notificaQtdCoelAbertasPorCarteira() {
			this.coelService.obterCoelAbertasPorCarteira()
				.then(coelAbertoRes => this.qtdCoelAbertas = coelAbertoRes.length)
				.catch(e => this.modalerror = e)
		},

		/**
		* atualiza quantidade de cobrancas eletronicas abertas no menu por carteira
		* @since 1.10.0
		* @author Amaro Silva
		* @param {String} clieSelec
		*/
		atualizaClienteSelecioado(clieSelec) {
			if (clieSelec) {
				this.usuario.usuaIdClieSelec = clieSelec.clieId;
				this.notificaQtdCoelAbertas();
			}
		},

		/**
		* monta url das imagens do tema
		* @since 1.17.06
		* @author Amaro Silva
		* @param {String} clieSelec
		*/
		defineImagens(tema = this.env && this.env.tema_default) {
			console.log('define tema', this.env, tema);
			this.logo = tema ? `webapi/resource/logo_${tema}.png` : null;
			this.logologin = tema ? `webapi/resource/logo_${tema}_login.png` : null;
			this.background = tema ? `webapi/resource/background_${tema}.png` : null;
		},

		/**
		* obtem o tema salva no navegador do ultimo acesso
		* @since 1.17.06
		* @author Amaro Silva
		*/
		obtemTemaUltimoAcesso() {
			const cookies = document.cookie.split(';'); 						// lista de cookies
			const temaCookie = cookies.find(x => x.includes(this.tema)) || ''; 	// filtra tema nos cookies
			const nomeTemaCookie = temaCookie.substr(temaCookie.indexOf('=') + 1) // extrai nome do tema no filtro cookies
			const temaSalvoNavegador = window.localStorage.getItem('TEMA') || nomeTemaCookie || null;
			return temaSalvoNavegador;
		},

		/**
		* seleciona o tema cadastrado na unidade de negocio
		* @since 1.17.06
		* @author Amaro Silva
		* @param {String} unegTema
		*/
		selecionaTema(unegTema = null) {
			const temaSalvo = this.obtemTemaUltimoAcesso();

			window.localStorage.setItem('TEMA', unegTema);
			document.cookie = `TEMA=${unegTema}`;

			// if (!temaSalvo || temaSalvo !== unegTema) return location.reload(true); //reload limpando chache
			this.tema = unegTema;
			this.defineImagens(this.tema);
		},

		/**
		* salva o titulo do site no cookie do navegador
		* @since 2.10.xx
		* @author Amaro Silva
		* @param {String} unegTituloSite
		*/
		defineTituloSite(unegTituloSite = null) {
			window.localStorage.setItem('TITULO_SITE', unegTituloSite);
			document.cookie = `TITULO_SITE=${unegTituloSite}`;
		},

		/**
		* add informações do dispositivo na variável env
		* @since 1.18.01
		* @author Amaro Silva
		*/
		infoDispositivo(e) {
			const dispositivo = {};
			dispositivo.width = $(window).width();
			dispositivo.mobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
			if (this.env) this.env.dispositivo = dispositivo;
		},

		/**
		 * retorna true para qualquer perfil que contenha o texto do role
		 * @since 1.20.01
		 * @author Amaro Silva
		 * @param {String} role
		 * @param {Array} perfis 
		 */
		temPerfil(role, perfis = []) {
			let contemPerfil = perfis.filter(p => role === p);
			return contemPerfil.length > 0;
		},

		/**
		 * link para download da planilha de itens
		 * @since 1.20.01
		 * @author Amaro Silva
		 */
		baixarPlanilhaItens() {
			this.planilhaItensService.downloadPlanilhaItens()
				.then(path => window.open(path, '_blank'))
				.catch(err => this.modalError = err);
		},

		/**
		 * Faz o download da planilha de itens drop shipping
		 */
		baixarPlanilhaDropshipping() {
			this.planilhaItensService.downloadPlanilhaItensDropshipping()
				.then(path => window.open(path, '_blank'))
				.catch(err => this.modalError = err);

		},

		/**
		 * retorna lista de marketplaces integrados com erro de autenticação
		 * @since 1.28.01
		 * @author Amaro Silva
		 */
		listAuthenticationErrors() {
			if (this.usuario && ['CLIENTE', 'PREPOSTO_CLIENTE', 'DROPSHIPPING', 'OPERADOR_SEPARAC'].includes(this.usuario.usuaRole)) {
				this.integracaoMarketplaceService.listAuthenticationErrors()
					.then(resp => this.errorsAuthMarketplace = resp)
					.catch(e => console.error(e))
			}
		},

		defineCorMenu({ emDestaque, styleCuston }) {
			let corFundo = '';
			const isHexColor = /^#([A-Fa-f0-9]{3}|[A-Fa-f0-9]{6})$/.test(this.env.cor_menu_em_destaque);
			if (emDestaque) corFundo = corFundo + ' em-destaque';
			if (emDestaque && !this.env.cor_menu_em_destaque) corFundo = corFundo + ' secondary-color';
			if (emDestaque && this.env.cor_menu_em_destaque) corFundo = corFundo + ' ' + this.env.cor_menu_em_destaque;
			if (emDestaque && isHexColor) corFundo = 'background-color: ' + this.env.cor_menu_em_destaque + ' !important;';
			return corFundo;
		},

		defineCorTextoMenu({ emDestaque, styleCuston }) {
			let corTexto = '';
			const isHexColor = /^#([A-Fa-f0-9]{3}|[A-Fa-f0-9]{6})$/.test(this.env.cor_text_menu_em_destaque);
			if (emDestaque) corTexto = corTexto + ' em-destaque';
			if (emDestaque && !this.env.cor_text_menu_em_destaque) corTexto = corTexto + ' white-text';
			if (emDestaque && this.env.cor_text_menu_em_destaque) corTexto = corTexto + ' ' + this.env.cor_text_menu_em_destaque;
			if (emDestaque && isHexColor) corTexto = 'color: ' + this.env.cor_text_menu_em_destaque + ' !important;';
			return corTexto;
		},

		checaVersaoSistemaModou() {
			const appVersion = window.localStorage.getItem('APP_VERSION');
			if (!(this.env && this.env.app_version)) return;
			const newVersion = this.env && this.env.app_version != appVersion;

			if (newVersion) window.localStorage.setItem('APP_VERSION', this.env.app_version);
			if (newVersion) location.reload(true); //reload limpando chache
		},

		/**
		 * link para download de catalogo pdf
		 * @since 2.05.0
		 * @author Amaro Silva
		 */
		montarParamsCatalogo() {
			return {
				emprId: this.emprIdCatalogo,
				unegId: this.unegIdCatalogo,
				atributo1: this.atributo1.join('|'),
				atributo2: this.atributo2.join('|'),
				atributo3: this.atributo3.join('|'),
				atributo4: this.atributo4.join('|'),
				atributo6: this.atributo6.join('|'),
				descricao: this.descricaoCatalogo,
				aplicacao: this.aplicacaoCatalogo,
				itensPorPagina: this.itensPorPaginaCatalogo || undefined,
			};
		},
		atributoCatalogoLabel(atributo) {
			if (!atributo.length) return 'TODAS';
			if (atributo.length === 1) return atributo[0];
			return `${atributo.length} opcoes selecionadas`;
		},
		atributosCatalogoFiltrados(lista, numero) {
			const filtro = (this.filtroAtributoCatalogo[numero] || '').trim().toLocaleUpperCase();
			if (!filtro) return lista;
			return lista.filter(valor => String(valor).toLocaleUpperCase().includes(filtro));
		},
		alternarAtributoCatalogo(numero) {
			this.catalogoAtributoAberto = this.catalogoAtributoAberto === numero ? null : numero;
		},
		limparAtributoCatalogo(nomeAtributo) {
			this[nomeAtributo] = [];
		},
		agendarAtualizacaoQuantidadeCatalogo() {
			clearTimeout(this.catalogoQuantidadeTimer);

			if (!this.showDialogCatalogo || this.mostrarMsgDownloadPdf) return;

			if (!this.emprIdCatalogo || !this.unegIdCatalogo) {
				this.quantidadeItensCatalogo = null;
				this.carregandoQuantidadeCatalogo = false;
				return;
			}

			this.carregandoQuantidadeCatalogo = true;
			this.catalogoQuantidadeTimer = setTimeout(() => this.atualizarQuantidadeCatalogo(), 350);
		},
		atualizarQuantidadeCatalogo() {
			if (!this.emprIdCatalogo || !this.unegIdCatalogo) return Promise.resolve();

			const reqSeq = ++this.catalogoQuantidadeReqSeq;

			this.carregandoQuantidadeCatalogo = true;
			return this.$http.get('item/catalogo/quantidade', { params: this.montarParamsCatalogo() })
				.then(response => response.json ? response.json() : response.data)
				.then(qtd => {
					if (reqSeq == this.catalogoQuantidadeReqSeq) this.quantidadeItensCatalogo = qtd;
				})
				.catch(e => {
					if (reqSeq == this.catalogoQuantidadeReqSeq) this.modalError = e;
				})
				.finally(() => {
					if (reqSeq == this.catalogoQuantidadeReqSeq) this.carregandoQuantidadeCatalogo = false;
				});
		},
		baixarCatalogo() {
			this.mostrarMsgDownloadPdf = true;

			const params = this.montarParamsCatalogo();

			this.topLoader.push(1);

			this.$http.get('item/catalogo', {
				params,
				responseType: 'blob'
			})
				.then(response => {
					if (!(response.data instanceof Blob)) {
						console.error("A resposta não é um Blob:", response.data);
						throw new Error("A resposta do servidor não é um Blob. Verifique o backend.");
					}

					const url = window.URL.createObjectURL(response.data);

					const link = document.createElement('a');
					link.href = url;
					link.setAttribute('download', 'catalogo.pdf');

					document.body.appendChild(link);
					link.click();

					link.remove();
					window.URL.revokeObjectURL(url);
				})
				.catch(error => {
					console.error('Erro ao baixar o catálogo:', error);
				})
				.finally(() => {
					this.topLoader.pop();
					this.showDialogCatalogo = false;
					this.mostrarMsgDownloadPdf = false;
				});
		},
		fecharModalCatalogo() {
			clearTimeout(this.catalogoQuantidadeTimer);
			this.showDialogCatalogo = false;
			this.emprIdCatalogo = null;
			this.unegIdCatalogo = null;
			this.itensPorPaginaCatalogo = '';
			this.atributo1 = [];
			this.atributo2 = [];
			this.atributo3 = [];
			this.atributo4 = [];
			this.atributo6 = [];
			this.catalogoAtributoAberto = null;
			this.filtroAtributoCatalogo = { 1: '', 2: '', 3: '', 4: '', 6: '' };
			this.descricaoCatalogo = '';
			this.aplicacaoCatalogo = '';
			this.quantidadeItensCatalogo = null;
			this.carregandoQuantidadeCatalogo = false;
		},
		carregarDadosCatalogo() {
			if (this.catalogoDadosPromise) return this.catalogoDadosPromise;

			this.catalogoDadosPromise = Promise.all([
				this.serviceFactory.atributo(),
				this.serviceFactory.empresa(),
				this.serviceFactory.unidadeNegocio()
			])
				.then(([atributoService, empresaService, unidadeNegocioService]) => {
					this.atributoService = atributoService;
					return Promise.all([
						empresaService.list(),
						unidadeNegocioService.listar()
					]);
				})
				.then(([empresas, unidadesNegocio]) => {
					this.empresas = empresas || [];
					this.unidadesNegocio = unidadesNegocio || [];

					if (!this.emprIdCatalogo && this.empresas.length) {
						const empresaUsuario = this.empresas.find(empresa =>
							empresa.emprId == (this.usuario && this.usuario.usuaIdEmpr));
						this.emprIdCatalogo = (empresaUsuario || this.empresas[0]).emprId;
					}
					if (!this.unegIdCatalogo && this.unidadesNegocio.length) {
						const unidadeUsuario = this.unidadesNegocio.find(uneg =>
							uneg.unegId == (this.usuario && this.usuario.usuaIdUneg));
						this.unegIdCatalogo = (unidadeUsuario || this.unidadesNegocio[0]).unegId;
					}

					return this.carregarAtributosCatalogo();
				})
				.finally(() => this.catalogoDadosPromise = null);

			return this.catalogoDadosPromise;
		},
		carregarAtributosCatalogo() {
			if (!this.atributoService || !this.emprIdCatalogo) return Promise.resolve();

			const emprId = this.emprIdCatalogo;
			return Promise.all([1, 2, 3, 4, 6].map(atrib =>
				this.atributoService.listByEmpr(atrib, emprId)))
				.then(([atributo1, atributo2, atributo3, atributo4, atributo6]) => {
					// Descarta uma resposta atrasada caso a filial tenha sido alterada.
					if (emprId != this.emprIdCatalogo) return;
					this.listAtributo1 = atributo1 || [];
					this.listAtributo2 = atributo2 || [];
					this.listAtributo3 = atributo3 || [];
					this.listAtributo4 = atributo4 || [];
					this.listAtributo6 = atributo6 || [];
				});
		},
		abrirNovaAbaVideoAjuda() {
			// if(this.urlVideoAjuda) window.open(this.urlVideoAjuda);

			if (this.urlVideoAjuda) {
				const width = 800;
				const height = 400;
				const left = (screen.width / 2) - (width / 2);
				const top = (screen.height / 2) - (height / 2);

				window.open(this.urlVideoAjuda, 'Video Ajuda', `width=${width},height=${height},top=${top},left=${left}, toolbar=no, menubar=no`);
				//this.showVideoAjuda = true;
			}
		},
		defineQtd(qtd) {
			console.log('defineQtd', qtd)
			if (!"alterarQuantidadeDetalhes".includes(qtd)) {
				this.quantidadeDetalhes = qtd;
			}
		},
		loadNotifier(bol) {
			if (bol) this.topLoader.push(1);
			else this.topLoader.pop();
		},
		confirmarRemoveTodos(pedcId, peddIds) {
			const confirmaSimNao = this.$refs.confirmaSimNao;
			confirmaSimNao.title = `Remover todos itens do carrinho?`;
			confirmaSimNao.mensagemModalConfirm = 'Tem certeza que deseja remover todos itens do carrinho?';
			confirmaSimNao.metodoModalConfirm = () => this.removeTodos(pedcId, peddIds);
			confirmaSimNao.confirmLabel = 'Sim';
			confirmaSimNao.cancelLabel = 'Não';
			confirmaSimNao.abrir();
		},
		removeTodos(pedcId, peddIds) {
			this.$http.delete(`carrinho/${pedcId}/detalhe/${peddIds}`)
				.catch(e => this.modalError = e)
				.then(() => this.$refs.CarrinhoView.getSubtotal())
				.finally(() => this.showCarrinhoView = false);
		},
		obterUsuario() {
			if(!(this.usuario && this.usuario.usuaRefExterno)) return;

			this.usuarioService.getByRef(this.usuario.usuaRefExterno)
				.then(usuario => this.usuario = usuario)
				.catch(e => this.modalError = e);
		},
	}
}
</script>
<style lang="scss">
.linhasJuntas {
	line-height: 1.8;
}

.espacador_menu {
	height: 150px;
}

#slide-out a.menu-link-with-badge {
	display: flex;
	align-items: center;
	min-height: 48px;
	height: auto;
	line-height: 20px;
	position: relative;
	padding-right: 58px;
}

#slide-out a.menu-link-with-badge i.material-icons {
	flex: 0 0 auto;
}

#slide-out a.menu-link-with-badge > span:not(.badge):not(.menu-pill-new) {
	display: block;
	flex: 1 1 auto;
	min-width: 0;
	white-space: normal;
	overflow-wrap: anywhere;
	padding: 8px 0;
}

#slide-out a.menu-link-with-badge .menu-pill-new {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	position: absolute;
	right: 10px;
	top: 50%;
	transform: translateY(-50%);
	width: 42px;
	height: 18px;
	line-height: 1;
	margin: 0;
	padding: 0;
	border-radius: 3px;
	font-size: 10px;
	font-weight: 700;
	text-transform: uppercase;
}

.fixed-action-btn.whatsApp {
	padding: 0;
	right: 20px;
	bottom: 15px;
}

.fixed-action-btn.whatsApp a {
	height: 60px;
	width: 60px;
}

.fixed-action-btn {
	bottom: 85px;
}

header .brand-logo {
	align-items: center;
	background-color: transparent;
	border-radius: 4px;
	cursor: pointer;
	display: flex;
	height: 54px;
	margin: 5px 0 0 8px;
	padding: 0 12px;
}

header .brand-logo img {
	display: block;
	filter: none;
	height: auto;
	margin: 0;
	max-height: 44px;
	mix-blend-mode: normal;
	object-fit: contain;
	width: auto;
}

/* Remove Arrows/Spinners Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
	-webkit-appearance: none;
	margin: 0;
}

/* Remove Arrows/Spinners Firefox */
input[type=number] {
	-moz-appearance: textfield;
}

.solutionSelect.invalid {
	border-bottom: 1px solid #F44336;
	box-shadow: 0 1px 0 0 #F44336;
}

.catalogo-multiselect {
	position: relative;
}

.catalogo-multiselect-trigger {
	align-items: center;
	background: #fff !important;
	border: 1px solid #9e9e9e;
	color: #333 !important;
	cursor: pointer;
	display: flex;
	height: 3rem;
	justify-content: space-between;
	padding: 0 8px;
	text-align: left;
	width: 100%;
}

.catalogo-multiselect-trigger .material-icons {
	color: #333 !important;
}

.catalogo-multiselect-opcoes {
	background: #fff;
	border: 1px solid #9e9e9e;
	box-shadow: 0 2px 5px rgba(0, 0, 0, .25);
	left: 0;
	max-height: 320px;
	overflow-y: auto;
	position: absolute;
	right: 0;
	top: 100%;
	z-index: 1000;
}

.catalogo-multiselect-filtro {
	align-items: center;
	background: #fff;
	border-bottom: 1px solid #ddd;
	display: flex;
	padding: 0 10px;
	position: sticky;
	top: 0;
	z-index: 1;
}

.catalogo-multiselect-filtro i {
	color: #757575;
	font-size: 20px;
	margin-right: 8px;
}

.catalogo-multiselect-filtro input[type=text] {
	box-sizing: border-box;
	height: 42px;
	margin: 0;
}

.catalogo-multiselect-opcao {
	align-items: center;
	cursor: pointer;
	display: flex;
	min-height: 36px;
	padding: 5px 10px;
}

.catalogo-multiselect-opcao:hover {
	background: #eee;
}

.catalogo-multiselect-opcao.selecionada {
	background: #e3f2fd;
}

.catalogo-multiselect-check {
	color: var(--primary-color);
	font-size: 20px;
	margin-right: 8px;
}

.catalogo-multiselect-opcao span {
	color: #333;
}

@media only screen and (max-width: 600px) {

	.fixed-action-btn {
		right: 10px !important;
	}

	.fixed-action-btn.whatsApp {
		bottom: 7px;
	}
}

:root {
    --primary-color: #3949AB;
    --primary-color-light: #5C6BC0;
    --primary-color-dark: #283593;
    --secondary-color: #C62828;
    --secondary-color-dark: #B71C1C;
}
header .brand-logo img.sombra-branca-logo {
    /* Cria uma silhueta branca suave ao redor da logo para destacá-la do laranja */
    filter: drop-shadow(1px 1px 0px #fff) drop-shadow(-1px -1px 0px #fff) drop-shadow(1px -1px 0px #fff) drop-shadow(-1px 1px 0px #fff);
}

nav {
    background-color: var(--primary-color) !important;
}

.primary-color {
    background-color: var(--primary-color) !important;
}

.primary-color-light {
    background-color: var(--primary-color-light) !important;
}

.primary-color-dark {
    background-color: var(--primary-color-dark) !important;
}

.secondary-color {
    background-color: var(--secondary-color) !important;
}

.secondary-color-dark {
    background-color: var(--secondary-color-dark) !important;
}
</style>



// WEBPACK FOOTER //
// App.vue?51271302